// admin 端图形验证码刷新 hook：与 web 端同构
const CaptchaRefresh = { mounted() {
	const img = this.el.querySelector("img");
	const refresh = () => {
		if (img) img.src = `/captcha?t=${Date.now()}`;
	};
	if (img) {
		img.addEventListener("click", refresh);
	}
	this.el.querySelectorAll("[data-captcha-refresh]").forEach((el) => el.addEventListener("click", refresh));
} };
export default CaptchaRefresh;
